var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariousGoods = function SvgVariousGoods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 17.333q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.176q0-.688.49-1.178Q5.146 14 5.833 14t1.177.49.49 1.177-.49 1.177-1.177.49m8.333 0q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.176q0-.688.49-1.178.49-.489 1.177-.489t1.177.49.49 1.177-.49 1.177-1.177.49M5.125 4l2 4.167h5.833L15.25 4zm-.792-1.667h12.292q.48 0 .729.427a.84.84 0 0 1 .02.865l-2.958 5.333a1.67 1.67 0 0 1-.614.646q-.385.23-.844.23H6.75L5.833 11.5h10v1.667h-10q-.937 0-1.417-.823t-.041-1.636L5.5 8.667l-3-6.334H.833V.667h2.708z"
  })));
};
export default SvgVariousGoods;